import React from "react";
import { StickyFooter } from "@origin-digital/ods-core";
import { FooterContent } from "./FooterContent";

export const Footer = () => {
  return (
    <StickyFooter>
      <FooterContent />
    </StickyFooter>
  );
};
